// extracted by mini-css-extract-plugin
export default {"crossReferencesList":"CrossReferencedEvent-module__crossReferencesList__T5acTbt"};